import seller1 from "../../img/seller1.jpg";
import seller2 from "../../img/seller2.jpg";
import seller3 from "../../img/seller3.jpg";
import seller4 from "../../img/seller4.jpg";
import seller5 from "../../img/seller5.jpg";

const TopSeller = [
  { id: 1, seller_name: "Layla Abkari", username: "@lela", imgSrc: seller1 },
  { id: 2, seller_name: "Abdo Boyka", username: "@abdo", imgSrc: seller2 },
  { id: 3, seller_name: "Ayoub Hanafi", username: "@ayoub", imgSrc: seller3 },
  { id: 4, seller_name: "Chaimae Azzaro", username: "@chaimae", imgSrc: seller4 },
  { id: 5, seller_name: "Joury Ben", username: "@joury", imgSrc: seller5 },
];

export default TopSeller;
